import { useState } from "react";
import { useTranslation } from "./useTranslation";

// Lifted out of the landing page's Layout component so both Layout and the
// new PageShell (used by every /vision, /partnership, ... page) can drive
// the shared Header's LanguageToggle consistently.
export const useLandingLanguage = () => {
  const { i18n } = useTranslation();
  const [locale, setLocale] = useState(i18n.language);

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
    setLocale(language);
  };

  return { locale, handleLanguageChange };
};
